import styled from 'styled-components'
import typeStyle from 'styles/typeStyle'

import ButtonMedium from '../../components/display/Button/Medium'
import SimpleLink from '../../components/display/SimpleLink'

export const CallToActionButton = styled(ButtonMedium)`
  ${typeStyle('-ds-font-lead')}
  letter-spacing: unset;
  text-transform: none;
  max-width: ${({ fullwidth }) => !fullwidth && 'fit-content'};
  padding: 0 30px;

  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LearnMoreLink = styled(SimpleLink)
  .withConfig({
    shouldForwardProp: (prop) => !['inverse'].includes(prop),
  })
  .attrs({
    textDecoration: 'none',
  })<{ inverse?: boolean }>`
  ${typeStyle('-ds-font-lead')}

  color: ${({ theme, inverse }) =>
    inverse ? theme?.['-ds-core-200']?.value : theme?.['-ds-core-400']?.value};

  &:hover,
  &:visited,
  &:link {
    color: ${({ theme, inverse }) =>
      inverse
        ? theme?.['-ds-core-200']?.value
        : theme?.['-ds-core-400']?.value};
  }
`

export const Title = styled.h2`
  ${typeStyle('-ds-font-title-2-regular')}
  color: ${({ theme }) => theme?.['-ds-core-300']?.value};
  margin: 0;
`

export const HeadingGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-02);
`

export const Subtitle = styled.h3`
  ${typeStyle('-ds-font-lead-light')}
  color: ${({ theme }) => theme?.['-ds-core-300']?.value};
  line-height: 1.7;
  margin: 0 0 30px 0;
`
